"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_onclickoutside_1 = require("react-onclickoutside");
var ArrowDownIcon_1 = require("../../Icons/ArrowDownIcon");
var year_dropdown_options_1 = require("./year_dropdown_options");
var getYear = require("date-fns/get_year");
var WrappedYearDropdownOptions = react_onclickoutside_1.default(year_dropdown_options_1.default);
var YearDropdown = /** @class */ (function (_super) {
    __extends(YearDropdown, _super);
    function YearDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.renderSelectOptions = function () {
            var minYear = _this.props.minDate
                ? getYear(_this.props.minDate)
                : 1900;
            var maxYear = _this.props.maxDate
                ? getYear(_this.props.maxDate)
                : 2100;
            var options = [];
            for (var i = minYear; i <= maxYear; i++) {
                options.push(React.createElement("option", { key: i, value: String(i) }, i));
            }
            return options;
        };
        _this.onSelectChange = function (e) {
            _this.onChange(parseInt(e.target.value, 10));
        };
        _this.renderSelectMode = function () {
            return (React.createElement("select", { value: String(_this.props.year), className: "ee_react-datepicker__year-select", onChange: _this.onSelectChange }, _this.renderSelectOptions()));
        };
        _this.renderReadView = function () {
            return (React.createElement("div", { key: "read", style: { visibility: 'visible' }, className: "ee_react-datepicker__year-read-view", onClick: _this.toggleDropdown },
                React.createElement("span", { className: "ee_react-datepicker__year-read-view--selected-year" }, _this.props.year),
                React.createElement("span", { className: "ee_react-datepicker__year-read-view--down-arrow" },
                    React.createElement(ArrowDownIcon_1.default, { title: "\u00D6ffnen", className: 'ee_react-datepicker__year-read-view--down-arrow-toggle' }))));
        };
        _this.renderDropdown = function () {
            return (React.createElement(WrappedYearDropdownOptions, { key: "dropdown", year: _this.props.year, onChange: _this.onChange, onCancel: _this.toggleDropdown, scrollableYearDropdown: _this.props.scrollableYearDropdown, includeDates: _this.props.includeDates, minDate: _this.props.minDate, maxDate: _this.props.maxDate }));
        };
        _this.renderScrollMode = function () {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [_this.renderReadView()];
            if (dropdownVisible) {
                result.unshift(_this.renderDropdown());
            }
            return result;
        };
        _this.onChange = function (year) {
            _this.toggleDropdown();
            if (year === _this.props.year) {
                return;
            }
            _this.props.onChange(year);
        };
        _this.toggleDropdown = function () {
            _this.setState(function (state) {
                return {
                    dropdownVisible: !state.dropdownVisible
                };
            });
        };
        _this.state = {
            dropdownVisible: false
        };
        return _this;
    }
    YearDropdown.prototype.render = function () {
        var renderedDropdown;
        switch (this.props.dropdownMode) {
            case 'scroll':
                renderedDropdown = this.renderScrollMode();
                break;
            case 'select':
                renderedDropdown = this.renderSelectMode();
                break;
            default:
                break;
        }
        var cn = classNames('ee_react-datepicker__year-dropdown-container', "ee_react-datepicker__year-dropdown-container--" + this.props.dropdownMode);
        return React.createElement("div", { className: cn }, renderedDropdown);
    };
    YearDropdown.displayName = 'YearDropdown';
    YearDropdown.propTypes = {
        dropdownMode: PropTypes.oneOf(['scroll', 'select']).isRequired,
        maxDate: PropTypes.object,
        minDate: PropTypes.object,
        onChange: PropTypes.func.isRequired,
        scrollableYearDropdown: PropTypes.bool,
        year: PropTypes.number.isRequired,
        includeDates: PropTypes.array
    };
    return YearDropdown;
}(React.Component));
exports.YearDropdown = YearDropdown;
exports.default = YearDropdown;
//# sourceMappingURL=year_dropdown.js.map
